/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_Li2_DescInputs */

const tr_iade_iptal_s4_li2_desc = /** @type {(inputs: Iade_Iptal_S4_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kutu işaretlenmeden satın alma tamamlanamaz. Cayma hakkını korumak isteyen Tüketici, hizmetin 14 günlük cayma süresi sonunda başlatılmasını destek@emonse.com üzerinden talep edebilir; bu süre içinde Sözleşme'den hiçbir gerekçe göstermeden cayabilir ve ödediği bedel iade edilir.`)
};

const en_iade_iptal_s4_li2_desc = /** @type {(inputs: Iade_Iptal_S4_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The purchase cannot be completed without ticking the box. A consumer who wishes to keep the right of withdrawal may request via destek@emonse.com that the service be started only at the end of the 14-day withdrawal period; within this period they may withdraw from the Agreement without giving any reason and the fee paid is refunded.`)
};

const de_iade_iptal_s4_li2_desc = /** @type {(inputs: Iade_Iptal_S4_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Ankreuzen des Feldes kann der Kauf nicht abgeschlossen werden. Ein Verbraucher, der sein Widerrufsrecht behalten möchte, kann über destek@emonse.com verlangen, dass die Dienstleistung erst nach Ablauf der 14-tägigen Widerrufsfrist beginnt; innerhalb dieser Frist kann er ohne Angabe von Gründen vom Vertrag zurücktreten und das gezahlte Entgelt wird erstattet.`)
};

const ru_iade_iptal_s4_li2_desc = /** @type {(inputs: Iade_Iptal_S4_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без отметки в поле покупка не может быть завершена. Потребитель, желающий сохранить право на отказ от договора, может через destek@emonse.com попросить начать оказание услуги только по истечении 14-дневного срока на отказ; в течение этого срока он вправе отказаться от Договора без указания причин, и уплаченная сумма возвращается.`)
};

/**
* | output |
* | --- |
* | "The purchase cannot be completed without ticking the box. A consumer who wishes to keep the right of withdrawal may request via destek@emonse.com that the se..." |
*
* @param {Iade_Iptal_S4_Li2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_li2_desc = /** @type {((inputs?: Iade_Iptal_S4_Li2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_Li2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_li2_desc(inputs)
	if (locale === "de") return de_iade_iptal_s4_li2_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_li2_desc(inputs)
	return tr_iade_iptal_s4_li2_desc(inputs)
});